import React from 'react';
import { CheckSign } from 'components';

interface AssetsDetailsDocsProps {
  docs: React.ReactNode;
}

const AssetsDetailsDocs: React.FC<AssetsDetailsDocsProps> = ({ docs }) => (
  <div className="assets-details__list-doc">
    <div>{docs}</div>
    <div>
      <CheckSign />
    </div>
  </div>
);

export default AssetsDetailsDocs;
